
<h2 mat-dialog-title class="text-center">{{ data.title || 'Confirm Action' }}</h2>
<mat-dialog-content class="text-center">
  {{ data.message || 'Are you sure you want to proceed?' }}
</mat-dialog-content>
<div class="d-flex justify-content-center">
  <mat-dialog-actions>
    <button mat-raised-button color="warn" (click)="onNoClick()">No</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">Yes</button>
  </mat-dialog-actions>
</div>

